import { EyeOpenIcon as EyeOpenIconBasic } from "../../nectarDesignTokens/icons/EyeOpenIcon";
import { withTokenSvgWrap } from "../withTokenSvgWrap";
export var EyeOpenIcon = withTokenSvgWrap(EyeOpenIconBasic);